import axiosInstance from './axios';
import joinURLParams from 'utils/joinUrlParams';
import {
  StockHoldingGainLossFilters,
  StockHoldingGainLossResponse,
  StockHoldingGainLossRow,
} from 'types/models/StockHoldingGainLoss';
const parseRow = (item: any): StockHoldingGainLossRow => ({
  globalProductId: String(item.global_product_id ?? ''),
  name: item.name ?? '',
  sku: item.sku ?? '',
  totalStock: Number(item.total_stock ?? 0),
  averageCost: Number(item.average_cost ?? 0),
  replacementCost: Number(item.replacement_cost ?? 0),
  historicalValue: Number(item.historical_value ?? 0),
  replacementValue: Number(item.replacement_value ?? 0),
  variation: Number(item.variation ?? 0),
  type: item.type ?? 'none',
});

const parseResponse = (data: any): StockHoldingGainLossResponse => {
  const raw = Array.isArray(data?.products) ? data.products : [];
  const totals = data?.totals ?? {};
  const pagination = data?.pagination ?? {};

  return {
    products: raw.map(parseRow),
    totals: {
      historicalValue: Number(totals?.historical_value ?? 0),
      replacementValue: Number(totals?.replacement_value ?? 0),
      variation: Number(totals?.variation ?? 0),
      gainCount: Number(totals?.gain_count ?? 0),
      lossCount: Number(totals?.loss_count ?? 0),
    },
    pagination: {
      currentPage: Number(pagination?.current_page ?? 1),
      perPage: Number(pagination?.per_page ?? raw.length),
      total: Number(pagination?.total ?? raw.length),
    },
  };
};

export const getStockHoldingGainLoss = async (
  filters: StockHoldingGainLossFilters,
  page = 1,
  perPage = 10,
): Promise<StockHoldingGainLossResponse> => {
  const { venueId, searchTerm, globalProductId, type, dateTo } = filters;

  const url = joinURLParams(
    { page, perPage, searchTerm, globalProductId, type, dateTo },
    `stock/holding-gain-loss/${venueId}`,
  );

  const { data } = await axiosInstance({
    method: 'get',
    url,
  });

  return parseResponse(data);
};

export const exportStockHoldingGainLoss = async (filters: StockHoldingGainLossFilters): Promise<Blob | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'post',
      url: `stock/holding-gain-loss/${filters.venueId}/export`,
      data: {
        searchTerm: filters.searchTerm || '',
        type: filters.type || '',
        dateTo: filters.dateTo || '',
        lang: 'es',
      },
      responseType: 'blob',
    });
    return data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
